import {Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from 'typeorm';

@Entity('work-calender')
export class WorkCalender{

    @PrimaryGeneratedColumn('increment', {name: 'id'})
    id: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('datetime', {
        name: 'date'
    })
    date: Date;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'shif'
    })
    shift: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'shift_code'
    })
    shiftCode: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'workstation_team'
    })
    workStationTeam: string;

    
    @Column("datetime", {
        nullable: false,
        name: 'in_time'
    })
    inTime: Date

    @Column("datetime", {
        nullable: true,
        name: "out_time"
    })
    outTime: Date;

    
    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'attendance_status'
    })
    attendanceStatus: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'leave_code'
    })
    leaveCode: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'holiday'
    })
    holiday: boolean;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'department'
    })
    department: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'contractor'
    })
    contractor: string;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}